import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export interface BreakpointFlags {
  /** Below 600px. Drawer nav, card lists, 44px targets. */
  isMobile: boolean;
  /** 600–899px. Icon rail, reduced table columns. */
  isTablet: boolean;
  /** 900px and up. Persistent sidebar, dense tables. */
  isDesktop: boolean;
}

/**
 * Single viewport class for JS branching.
 * CSS-only rules stay in `sx` via `theme.breakpoints`. Do not call `useMediaQuery` elsewhere.
 */
export function useBreakpoint(): BreakpointFlags {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'), { noSsr: true });
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  return { isMobile, isTablet, isDesktop };
}
